import { useMemo } from 'react'

import { Popover } from 'antd'
import { useTheme } from 'antd-style'
import { round } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { InputNumber } from '@eastcoal/formily/components/InputNumber'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { Segmented } from '@eastcoal/formily/components/Segmented'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { NeSizeIcon } from '@eastcoal/icon/NeSizeIcon'

import { MenuButton } from '../../../MenuButton'
import { useImageCardStore } from '../../Store/hooks/useStore'

const grid = {
  columns: 2
}

const layout = {
  fullness: true
}

export const SizeDropdown = () => {
  const {
    ratio,
    originalWidth,
    originalHeight,
    currentWidth,
    currentHeight,
    setCurrentSize,
    getPopupContainer
  } = useImageCardStore(state =>
    pick(state, [
      'ratio',
      'originalWidth',
      'originalHeight',
      'currentWidth',
      'currentHeight',
      'setCurrentSize',
      'getPopupContainer'
    ])
  )

  const items: SchemaItem[] = [
    {
      title: '宽',
      name: 'width',
      type: 'number',
      'x-component': InputNumber,
      'x-component-props': {
        onBlur() {
          const width = form.values.width
          setCurrentSize({
            width: width,
            height: width / ratio
          })
        }
      },
      'x-decorator': FormItem,
      'x-decorator-props': {
        gridSpan: 1
      }
    },
    {
      title: '高',
      name: 'height',
      type: 'number',
      'x-component': InputNumber,
      'x-component-props': {
        onBlur() {
          const height = form.values.height
          setCurrentSize({
            height,
            width: height * ratio
          })
        }
      },
      'x-decorator': FormItem,
      'x-decorator-props': {
        gridSpan: 1
      }
    },
    {
      title: '',
      name: 'scale',
      type: 'number',
      enum: [
        {
          label: '25%',
          value: 0.25
        },
        {
          label: '50%',
          value: 0.5
        },
        {
          label: '75%',
          value: 0.75
        },
        {
          label: '100%',
          value: 1
        }
      ],
      'x-component': Segmented,
      'x-component-props': {
        onChange() {
          const scale = form.values.scale
          setCurrentSize({
            width: originalWidth * scale,
            height: originalHeight * scale
          })
        }
      },
      'x-decorator': FormItem,
      'x-decorator-props': {
        gridSpan: 2,
        feedbackLayout: 'none'
      }
    }
  ]

  const values = useMemo(
    () => ({
      width: currentWidth,
      height: currentHeight,
      scale: round((currentWidth / originalWidth) * 100) / 100
    }),
    [currentHeight, currentWidth, originalWidth]
  )

  const form = useCreationForm({
    values
  })

  const content = (
    <SchemaForm
      form={form}
      grid={grid}
      layout={layout}
      name='imageSizeForm'
      schema={items}
    />
  )

  const theme = useTheme()

  return (
    <Popover
      arrow={false}
      content={content}
      getPopupContainer={getPopupContainer}
      placement='bottomLeft'
      trigger='click'
      styles={{
        container: {
          padding: theme.padding,
          width: 320
        }
      }}
    >
      <MenuButton icon={<NeSizeIcon />} tooltip='图片尺寸'>
        宽高
      </MenuButton>
    </Popover>
  )
}
